import { Car } from "./types/CarTypes"

const GBR = {
  name: "GBR",
  continent: "EURO"
}
const FRA = {
  name: "FRA",
  continent: "EURO"
}
const GER = {
  name: "GER",
  continent: "EURO"
}
const ITA = {
  name: "ITA",
  continent: "EURO"
}
const CZE = {
  name: "CZE",
  continent: "EURO"
}
const SWE = {
  name: "SWE",
  continent: "EURO"
}
const CHI = {
  name: "CHI",
  continent: "ASIA"
}
const KOR = {
  name: "KOR",
  continent: "ASIA"
}
const JAP = {
  name: "JAP",
  continent: "ASIA"
}
const USA = {
  name: "USA",
  continent: "AMER"
}

const STELLANTIS = {
  name: "Stellantis"
}
const BMW_GROUP = {
  name: "BMW Group"
}
const GM = {
  name: "GM"
}
const RENAULT_GROUP = {
  name: "Renault Group"
}
const VW_GROUP = {
  name: "VW Group"
}
const HYUNDAI_MC = {
  name: "Hyundai MC"
}
const TATA_MOTORS = {
  name: "Tata Motors"
}
const TOYOTA_MC = {
  name: "Toyota MC"
}
const ZGH = {
  name: "ZGH Group"
}

const ALFA_ROMEO = {
  name: "Alfa Romeo",
  country: ITA,
  parent: STELLANTIS
}
const ASTON_MARTIN = {
  name: "Aston Martin",
  country: GBR
}


const AUDI = {
  name: "Audi",
  country: GER,
  parent: VW_GROUP
}

const BENTLEY = {
  name: "Bentley",
  country: GBR,
  parent: BMW_GROUP
}


const BMW = {
  name: "BMW",
  country: GER,
  parent: BMW_GROUP
}

const BUGATTI = {
  name: "Bugatti",
  country: FRA,
  parent: VW_GROUP
}
const CHEVROLET = {
  name: "Chevrolet",
  country: USA,
  parent: GM
}
const CITROEN = {
  name: "Citroën",
  country: FRA,
  parent: STELLANTIS
}

const FERRARI = {
  name: "Ferrari",
  country: ITA
}
const FIAT = {
  name: "FIAT",
  country: ITA,
  parent: STELLANTIS
}
const FORD = {
  name: "Ford",
  country: USA
}
const HAVAL = {
  name: "Haval",
  country: CHI
}
const HONDA = {
  name: "Honda",
  country: JAP
}
const HYUNDAI = {
  name: "Hyundai",
  country: KOR,
  parent: HYUNDAI_MC
}
const JAGUAR = {
  name: "Jaguar",
  country: GBR,
  parent: TATA_MOTORS
}
const JEEP = {
  name: "Jeep",
  country: USA,
  parent: STELLANTIS
}
const KIA = {
  name: "KIA",
  country: KOR,
  parent: HYUNDAI_MC
}

const LAMBORGHINI = {
  name: "Lamborghini",
  country: ITA,
  parent: VW_GROUP
}
const LAND_ROVER = {
  name: "Land Rover",
  country: GBR,
  parent: TATA_MOTORS
}
const LEXUS = {
  name: "Lexus",
  country: JAP,
  parent: TOYOTA_MC
}
const LOTUS = {
  name: "Lotus",
  country: GBR,
  parent: ZGH
}

const MASERATI = {
  name: "Maserati",
  country: ITA,
  parent: STELLANTIS
}
const MAZDA = {
  name: "Mazda",
  country: JAP
}

const MERC = {
  name: "Mercedes",
  country: GER
}
const MINI = {
  name: "Mini",
  country: GBR,
  parent: BMW_GROUP
}
const MITSUBISHI = {
  name: "Mitsubishi",
  country: JAP
}
const NISSAN = {
  name: "Nissan",
  country: JAP,
  parent: RENAULT_GROUP
}

const PEUGEOT = {
  name: "Peugeot",
  country: FRA,
  parent: STELLANTIS
}
const POLESTAR = {
  name: "Polestar",
  country: SWE,
  parent: ZGH
}

const PORSCHE = {
  name: "Porsche",
  country: GER,
  parent: VW_GROUP
}

const RENAULT = {
  name: "Renault",
  country: FRA,
  parent: RENAULT_GROUP
}
const ROLLS_ROYCE = {
  name: "Rolls-Royce",
  country: GBR,
  parent: BMW_GROUP
}

const SKODA = {
  name: "Skoda",
  country: CZE,
  parent: VW_GROUP
}
const SUBARU = {
  name: "Subaru",
  country: JAP,
  parent: TOYOTA_MC
}

const TESLA = {
  name: "Tesla",
  country: USA,
}
const TOYOTA = {
  name: "Toyota",
  country: JAP,
  parent: TOYOTA_MC
}
const VOLKSWAGEN = {
  name: "VW",
  country: GER,
  parent: VW_GROUP
}
const VOLVO = {
  name: "Volvo",
  country: SWE,
  parent: ZGH
}

const COUPE = {
  name: "Coupe",
  family: "2 Door"
}
const CONVERTIBLE = {
  name: "Convertible",
  family: "2 Door"
}
const SEDAN = {
  name: "Sedan",
  family: "4/5 Door"
}
const WAGON = {
  name: "Wagon",
  family: "4/5 Door"
}
const HATCH = {
  name: "Hatch",
  family: "4/5 Door"
}
const SMALL_SUV = {
  name: "Small SUV",
  family: "SUV"
}
const LARGE_SUV = {
  name: "Large SUV",
  family: "SUV"
}

export const allCars: Car[] = [
  {
    manufacturer: ALFA_ROMEO,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Giulia"
  },
  {
    manufacturer: ALFA_ROMEO,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Stelvio"
  },
  {
    manufacturer: ASTON_MARTIN,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "V8 Coupe"
  },
  {
    manufacturer: ASTON_MARTIN,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "V12 Vantage"
  },
  {
    manufacturer: ASTON_MARTIN,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "DBX"
  },
  {
    manufacturer: AUDI,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "A3"
  },
  {
    manufacturer: AUDI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "A4"
  },
  {
    manufacturer: AUDI,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "A4 Allroad"
  },
  {
    manufacturer: AUDI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "A6"
  },
  {
    manufacturer: AUDI,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "A6 Allroad"
  },
  {
    manufacturer: AUDI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "A8"
  },
  {
    manufacturer: AUDI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "TT"
  },
  {
    manufacturer: AUDI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "R8"
  },
  {
    manufacturer: AUDI,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Q3"
  },
  {
    manufacturer: AUDI,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "Q5 Hybrid"
  },
  {
    manufacturer: AUDI,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Q7"
  },
  {
    manufacturer: AUDI,
    bodyStyle: LARGE_SUV,
    poweredBy: "EV",
    model: "E-Tron"
  },
  {
    manufacturer: BENTLEY,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Continental GT"
  },
  {
    manufacturer: BENTLEY,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Flying Spur"
  },
  {
    manufacturer: BENTLEY,
    bodyStyle: SEDAN,
    poweredBy: "Hybrid",
    model: "Flying Spur Hybrid"
  },
  {
    manufacturer: BENTLEY,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Bentayga"
  },
  {
    manufacturer: BENTLEY,
    bodyStyle: LARGE_SUV,
    poweredBy: "Hybrid",
    model: "Bentayga Hybrid"
  },
  {
    manufacturer: BMW,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "3 Series"
  },
  {
    manufacturer: BMW,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "Z4"
  },
  {
    manufacturer: BMW,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "5 Series"
  },
  {
    manufacturer: BMW,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "6 Series"
  },
  {
    manufacturer: BMW,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "7 Series"
  },
  {
    manufacturer: BMW,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "i Series"
  },
  {
    manufacturer: BMW,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "X3"
  },
  {
    manufacturer: BMW,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "X7"
  },
  {
    manufacturer: BUGATTI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Chiron"
  },
  {
    manufacturer: CHEVROLET,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Corvette"
  },
  {
    manufacturer: CHEVROLET,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "Corvette Convertible"
  },
  {
    manufacturer: CITROEN,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "C3"
  },
  {
    manufacturer: CITROEN,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "C3 Aircross"
  },
  {
    manufacturer: CITROEN,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "C4"
  },
  {
    manufacturer: CITROEN,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "e-C4"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: COUPE,
    poweredBy: "Hybrid",
    model: "SF90 Stradale"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: CONVERTIBLE,
    poweredBy: "Hybrid",
    model: "SF90 Spider"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Roma"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: COUPE,
    poweredBy: "Hybrid",
    model: "296 GTB"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "F8 Tributo"
  },
  {
    manufacturer: FERRARI,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "F8 Spider"
  },
  {
    manufacturer: FIAT,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "500"
  },
  {
    manufacturer: FIAT,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "595C"
  },
  {
    manufacturer: FORD,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Focus"
  },
  {
    manufacturer: FORD,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Puma"
  },
  {
    manufacturer: FORD,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Everest"
  },
  {
    manufacturer: FORD,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Mustang"
  },
  {
    manufacturer: FORD,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "Mustang Convertible"
  },
  {
    manufacturer: HAVAL,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "H6"
  },
  {
    manufacturer: HONDA,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Civic"
  },
  {
    manufacturer: HONDA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Accord"
  },
  {
    manufacturer: HONDA,
    bodyStyle: SEDAN,
    poweredBy: "Hybrid",
    model: "Accord Hybrid"
  },
  {
    manufacturer: HONDA,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "CR-V"
  },
  {
    manufacturer: HONDA,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "HR-V"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "Ioniq 5"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Kona"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "Kona Electric"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Santa Fe"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Veloster"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Accent"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Elantra"
  },
  {
    manufacturer: HYUNDAI,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "Ioniq Hybrid"
  },
  {
    manufacturer: LAND_ROVER,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Range Rover Evoque"
  },
  {
    manufacturer: LAND_ROVER,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Range Rover"
  },
  {
    manufacturer: LAND_ROVER,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Defender"
  },
  {
    manufacturer: LAND_ROVER,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Discovery"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "2"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "3"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "6"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "CX-5"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "CX-9"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "MX-5"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "MX-5 RF"
  },
  {
    manufacturer: MAZDA,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "MX-30"
  },
  {
    manufacturer: JAGUAR,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "XF"
  },
  {
    manufacturer: JAGUAR,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "F-Type"
  },
  {
    manufacturer: JAGUAR,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "I-Pace"
  },
  {
    manufacturer: JAGUAR,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "F-Pace"
  },
  {
    manufacturer: JEEP,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Grand Cherokee"
  },
  {
    manufacturer: JEEP,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Wrangler"
  },
  {
    manufacturer: KIA,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "EV6"
  },
  {
    manufacturer: KIA,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Rio"
  },
  {
    manufacturer: KIA,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Stinger"
  },
  {
    manufacturer: KIA,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Niro"
  },
  {
    manufacturer: KIA,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "Niro Plug-In"
  },
  {
    manufacturer: KIA,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "Niro EV"
  },
  {
    manufacturer: KIA,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Sorento"
  },
  {
    manufacturer: KIA,
    bodyStyle: LARGE_SUV,
    poweredBy: "Hybrid",
    model: "Sorento Plug-In"
  },
  {
    manufacturer: LAMBORGHINI,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Urus"
  },
  {
    manufacturer: LAMBORGHINI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Huracan Evo"
  },
  {
    manufacturer: LAMBORGHINI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Aventador"
  },
  {
    manufacturer: LAMBORGHINI,
    bodyStyle: COUPE,
    poweredBy: "Hybrid",
    model: "Sian"
  },
  {
    manufacturer: LEXUS,
    bodyStyle: SEDAN,
    poweredBy: "Hybrid",
    model: "ES Range"
  },
  {
    manufacturer: LEXUS,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "LX Range"
  },
  {
    manufacturer: LEXUS,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "CT Range"
  },
  {
    manufacturer: LEXUS,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "NX Range"
  },
  {
    manufacturer: LOTUS,
    bodyStyle: COUPE,
    poweredBy: "EV",
    model: "Evija"
  },
  {
    manufacturer: MASERATI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Ghibli"
  },
  {
    manufacturer: MASERATI,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Quattroporte"
  },
  {
    manufacturer: MASERATI,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Levante"
  },
  {
    manufacturer: MERC,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "C Class"
  },
  {
    manufacturer: MERC,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "E Class"
  },
  {
    manufacturer: MERC,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "AMG C43"
  },
  {
    manufacturer: MERC,
    bodyStyle: WAGON,
    poweredBy: "Hybrid",
    model: "E Class All-Terrain"
  },
  {
    manufacturer: MERC,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "S Class"
  },
  {
    manufacturer: MERC,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "GL Class"
  },
  {
    manufacturer: MERC,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "EQA Class"
  },
  {
    manufacturer: MINI,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Cooper"
  },
  {
    manufacturer: MINI,
    bodyStyle: COUPE,
    poweredBy: "EV",
    model: "SE"
  },
  {
    manufacturer: MITSUBISHI,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "Outlander PHEV"
  },
  {
    manufacturer: NISSAN,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "Leaf"
  },
  {
    manufacturer: NISSAN,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Juke"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "208"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "2008"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "e-2008"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "308"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "308 Hybrid"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "308 SW"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: WAGON,
    poweredBy: "Hybrid",
    model: "308 SW Hybrid"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "3008"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "3008 Hybrid"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "508"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: SEDAN,
    poweredBy: "Hybrid",
    model: "508 Hybrid"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "508 SW"
  },
  {
    manufacturer: PEUGEOT,
    bodyStyle: WAGON,
    poweredBy: "Hybrid",
    model: "508 SW Hybrid"
  },
  {
    manufacturer: POLESTAR,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "2"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Macan"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Cayenne"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "911"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "911 Convertible"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Cayman"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: CONVERTIBLE,
    poweredBy: "ICE",
    model: "Boxster"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Panamera"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "Panamera Hybrid"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "Panamera Turismo"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: WAGON,
    poweredBy: "Hybrid",
    model: "Panamera Turismo Hybrid"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: SEDAN,
    poweredBy: "EV",
    model: "Taycan"
  },
  {
    manufacturer: PORSCHE,
    bodyStyle: WAGON,
    poweredBy: "EV",
    model: "Taycan Cross Turismo"
  },
  {
    manufacturer: RENAULT,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "Zoe"
  },
  {
    manufacturer: RENAULT,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Megane"
  },
  {
    manufacturer: RENAULT,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Captur"
  },
  {
    manufacturer: ROLLS_ROYCE,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Ghost"
  },
  {
    manufacturer: SKODA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Octavia"
  },
  {
    manufacturer: SKODA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Superb"
  },
  {
    manufacturer: SKODA,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Kamiq"
  },
  {
    manufacturer: SKODA,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "Kodiak"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Impreza"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "WRX"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "XV"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "XV Hybrid"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Forester"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "Forester Hybrid"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "Outback"
  },
  {
    manufacturer: SUBARU,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "BRZ"
  },
  {
    manufacturer: TESLA,
    bodyStyle: SEDAN,
    poweredBy: "EV",
    model: "Model 3"
  },
  {
    manufacturer: TESLA,
    bodyStyle: HATCH,
    poweredBy: "EV",
    model: "Model S"
  },
  {
    manufacturer: TESLA,
    bodyStyle: LARGE_SUV,
    poweredBy: "EV",
    model: "Model X"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "Prius"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Corolla"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: HATCH,
    poweredBy: "Hybrid",
    model: "Corolla Hybrid"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Camry"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: SEDAN,
    poweredBy: "Hybrid",
    model: "Camry Hybrid"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "RAV4"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "RAV4 Hybrid"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: LARGE_SUV,
    poweredBy: "ICE",
    model: "LandCruiser"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "86"
  },
  {
    manufacturer: TOYOTA,
    bodyStyle: COUPE,
    poweredBy: "ICE",
    model: "Supra"
  },
  {
    manufacturer: VOLKSWAGEN,
    bodyStyle: HATCH,
    poweredBy: "ICE",
    model: "Golf"
  },
  {
    manufacturer: VOLKSWAGEN,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "Passat"
  },
  {
    manufacturer: VOLKSWAGEN,
    bodyStyle: SMALL_SUV,
    poweredBy: "ICE",
    model: "Tiguan"
  },
  {
    manufacturer: VOLKSWAGEN,
    bodyStyle: SMALL_SUV,
    poweredBy: "EV",
    model: "ID.4"
  },
  {
    manufacturer: VOLVO,
    bodyStyle: SMALL_SUV,
    poweredBy: "Hybrid",
    model: "XC60 Recharge"
  },
  {
    manufacturer: VOLVO,
    bodyStyle: LARGE_SUV,
    poweredBy: "Hybrid",
    model: "XC90 Recharge"
  },
  {
    manufacturer: VOLVO,
    bodyStyle: SEDAN,
    poweredBy: "ICE",
    model: "S60"
  },
  {
    manufacturer: VOLVO,
    bodyStyle: WAGON,
    poweredBy: "ICE",
    model: "V60"
  },
]